export default __webpack_public_path__ + "static/media/badger.c6d087a2.png";